export const initialStates = {
    user: [],
    credentials:[],
    connectAccountId:"",
    forgotPasswordData: null
  };
  
